<template>
  <div>
    <template v-if="count">
      <div v-for="v in list" :key="`card-add-record-${v.id}`" class="item-box">
        <div class="icon-box">
          <v-icon :name="getCardTypeIconByType(v.card_type_id)"/>
        </div>
        <div class="item-content border-bottom">
          <div class="record-list-item flex-justify-between">
            <div class="record-list-title">{{v.card_type_name}}</div>
            <div class="time accent-color">{{ v.add_time | timeToYmdHi }}</div>
          </div>
          <div class="record-list-item">
            课卡名称：「<router-link :to="RouteConfig.cardDetail.to(v.card_id)" class="primary-color">{{ v.card_name }}</router-link>」；
            课卡 ID：「<span class="success-color">{{v.card_id}}</span>」；
            办卡日期：「<span class="success-color">{{ v.register_time | timeToYmd }}</span>」；
            自动开卡日期：「<span v-if="v.start_time_auto" class="success-color">{{ v.start_time_auto | timeToYmdHi }}</span><span v-else class="info-color">未设置</span>」；
            有效天数：「<span class="success-color">{{ v.expire_days }}</span> 天」；
            有效次数：「<template v-if="v.is_number_limit">
                          <span class="success-color">{{ v.expire_number | toYuan }}</span> 次
                       </template>
                       <span v-else class="success-color">无限制</span>」；
            禁止预约专栏：「<span v-if="v.is_disable_column" class="danger-color">是</span><span v-else class="success-color">否</span>」；
            适用范围：「<span class="success-color">{{ v.store_names ? `仅限${ v.store_names }店使用` : '全国通用'}}</span>」；
            <template v-if="v.store_names">
              仅限{{ v.store_names }}店使用天数：「<span class="success-color">{{ v.store_limit_expire_days }}</span> 天」；
            </template>
            付款方式：「<span class="success-color">{{ findPaymentModeName(v.card_payment_mode_id) }}</span>」；
            <template v-if="v.you_zan_number">
              有赞券码：「<span class="success-color">{{ v.you_zan_number }}</span>」；
              有赞核销金额：「<span class="success-color">{{ v.you_zan_payment | toYuan }}</span> 元」；
            </template>
            实际付款：「<span class="success-color">{{ v.actual_payment | toYuan }}</span> 元」；
            <template v-if="v.integral">
              积分抵扣：「<span class="success-color">{{ v.integral | toYuan }}</span> 元」；
            </template>
            <template v-if="v.vouchers && v.vouchers.length">
              代金券抵扣：<span v-for="(voucher, index) in v.vouchers" :key="voucher.voucher_id">「<router-link :to="RouteConfig.voucherDetail.to(voucher.voucher_id)" class="primary-color">{{ voucher.voucher_type_name }}</router-link>」<span v-if="index < v.vouchers.length - 1">、</span></span>，
              抵扣「<span class="danger-color">{{ v.voucher_amount_in_cents | toYuan }}</span> 元」；
            </template>
            付款凭证：「<a v-if="v.receipt" class="primary-color" :href="v.receipt" target="_blank">{{ v.receipt }}</a><span v-else class="info-color">未上传</span>」；
            付款备注：「<span v-if="v.payment_remark">{{ v.payment_remark }}</span><span v-else class="info-color">未填写</span>」；
            备注文件：「<template v-if="v.remark_files && v.remark_files.length"><template v-for="(f, k) in v.remark_files"><a :key="`remark-thumb-${k}`" class="remark-inline-link" :href="f.file_url" target="_blank" :title="f.file_name || f.file_url"><img class="remark-inline-thumb" :src="f.file_url" alt=""></a></template></template><span v-else class="info-color">未上传</span>」；
            课消：「<span class="success-color">{{ v.unit_price | toYuan }}</span> 元」。
            审核备注：「<span v-if="v.pass_remark" class="danger-color">{{ v.pass_remark }}</span><span v-else class="info-color">无</span>」；
          </div>
          <div class="store-name accent-color">
            <span v-if="v.administrator_name" class="operator">办卡人：{{ v.administrator_name }}</span>
            办卡所在门店：{{ v.store_name }}
          </div>
        </div>
      </div>

      <div v-if="count" class="pagination-box">
        <el-pagination
          :background="true"
          :current-page.sync="page"
          :page-size.sync="size"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="pageSizes"
          :total="count"
          @size-change="handlePageChange"
          @current-change="handlePageChange"
        />
      </div>
    </template>
    <div v-else class="empty-tip-box">暂无办卡记录</div>
  </div>
</template>

<script>
import scrollTo from "@/utils/scroll-to";
import { getCardTypeIconByType } from "@/enums/cardTypes";
import { getAddRecordsByStudentId } from "@/api/card";
import RouteConfig from "@/router/config";
import { findPaymentModeName } from "@/enums/paymentModes";

export default {
  props: {
    studentId: Number,
  },
  data: () => ({
    RouteConfig,
    list: [],
    count: 0,
    page: 1,
    size: 8,
    pageSizes: [10, 20, 30, 50],
  }),
  methods: {
    findPaymentModeName,
    getCardTypeIconByType,
    async getList() {
      const { isError, data } = await getAddRecordsByStudentId({
        student_id: this.studentId,
        page: this.page,
        size: this.size,
      });
      if (isError) return;

      this.list = data.list;
      this.count = data.count;
    },
    handlePageChange() {
      this.getList();
      scrollTo(0, 350);
    },
  },
  beforeMount() {
    this.getList();
  },
};
</script>

<style src="@/components/student-detail-record.css" scoped/>
<style scoped>
.remark-inline-link {
  display: inline-block;
  margin-right: 4px;
}

.remark-inline-thumb {
  width: 36px;
  height: 36px;
  vertical-align: middle;
  border: 1px solid #ebeef5;
  border-radius: 3px;
  object-fit: cover;
}
</style>
